import { APP_CONFIG } from '@/lib/config/constants'

export interface FeedbackPayload {
  email: string
  message: string
}

/**
 * Validates feedback data before submission
 */
export function validateFeedback(payload: FeedbackPayload): void {
  if (!payload.message.trim()) {
    throw new Error('Message is required')
  }

  if (payload.message.length < APP_CONFIG.MIN_FEEDBACK_LENGTH) {
    throw new Error(`Message must be at least ${APP_CONFIG.MIN_FEEDBACK_LENGTH} characters`)
  }

  if (payload.email && !payload.email.includes('@')) {
    throw new Error('Please provide a valid email address')
  }
}
